/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
import { Container } from "inversify";
import { computed } from "vue";
import fechaComp from "../../../../../common/infrastructure/funcionescompartidas/fechaComp";
import { IapCatalog } from "../../../catalog/domain/iapCatalog";
import { TYPES } from "../../../../../common/domain/types";
import HelperLoading from "../../../../../common/infrastructure/funciones/HelperLoading";
import SqlTypesConst from "../../../../../common/domain/constantes/SqlTypesConst";
import HelperCommon from "../../../../../common/infrastructure/funciones/HelperCommon";
//import { IServiceComponentDataSourceField } from "../../../component/application/IServiceComponentDataSourceField";
import ProductQuestionTypeConst from "../../../../../common/domain/constantes/ProductQuestionTypeConst";
import GestionConst from "../../../../../common/domain/constantes/GestionConst";
import { IServiceCatalog } from "../../../catalog/application/IServiceCatalog";
import { IapComponentDataSource } from "../../../component/domain/iapComponentDataSource";
import { IServiceComponentDataSource } from "../../../component/application/IServiceComponentDataSource";
import { IapDataSourceField } from "../../../datasource/domain/iapDataSourceField";
import { fetchWrapper } from "../../../../../common/infrastructure/funciones/helperFetch";
import Environment from "../../../../../common/domain/constantes/environment";
import DataSourceConst from "./dataSourceConst";
import { IapCatalogType } from "../../../catalog/domain/iapCatalogType";
import DataSourceUtilComp from "./dataSourceUtilComp";
import CatalogDataTypeConst from "../../../catalog/domain/const/CatalogDataTypeConst";
import { useStore } from "vuex";
import CatalogExpConst from "../../../catalog/domain/const/CatalogExpConst";
import CatalogObjectTypeConst from "../../../catalog/domain/const/CatalogObjectTypeConst";
import { LocalService } from "../../../../../common/infrastructure/servicios";
import { ExpresionEngine } from "../../../expression/infrastructure/helper/expressionEngine";
import { IapExpression } from '../../../expression/domain/iapExpression';
import HelperUtils from "../../../../../common/infrastructure/funciones/HelperUtils";
import { IapDataSource } from "../../../datasource/domain/iapDataSource";


export default function DataSourceComp(
  container: Container,
  props: any,
  emit: any,
  t: any,
  dscInput:  IapComponentDataSource,
  catalogos: IapCatalog[],
  store:any,
  dsInput?:IapDataSource
) {

  const { formateaFecha,formateaFechaHoraLarga,formateaFechaHora } = fechaComp();
/*
  const catalogos = computed({
    //get: () => props.catalogosData as IapCatalog[],
    //set: (val) => emit("update:catalogosData", val),
    
  });
  */

  const dataFilter = computed({
    get: () => props.modelValue,
    set: (val) => emit("update:modelValue", val),
  });

  const dataSearchResult = computed({
    get: () => props.dataSearch,
    set: (val) => emit("update:dataSearch", val),
  });

  const tablas = computed(() => {

    if(dsInput){
      return dsInput.iapDataSourceTableAliases;
    }
    return dscInput?.dataSource.iapDataSourceTableAliases;
  })

  const tablasData = computed(() => {
    
    if(dsInput){
      return dsInput.iapDataSourceFields;
    }
    return dscInput?.dataSource.iapDataSourceFields
  })

  const dataBaseId = computed(() => {
    
    if(dsInput){
      return dsInput?.iapDataSourceDataBase?.idBaseDatos
    }
    return dscInput?.dataSource?.iapDataSourceDataBase?.idBaseDatos;
  })

const { isType,
  isCatalogType,
  isCatalogTypeByFieldId,
  isFilterVisible,
  isIdCampoType,
  isColumnType,
  isColumnIdtipoCampoType,
  isTableType,
  hasLookUpType,
  hasLookUpByFieldId,
  hasLookUpByFieldType,
  getLookUpByFieldId} = DataSourceUtilComp(props.compDataSource,store)
 
 
  const getDataSource = (applicationId: number, componentId: number) => {
    return new Promise<IapComponentDataSource>((resolve) => {
      if (container) {
        const _srv = container.get<IServiceComponentDataSource>(
          TYPES.COMPONENT_DATASOURCE_FIELD_REPOSITORY
        );
        HelperLoading.showLoading();
        _srv
          .getByComponentId(applicationId, componentId)
          .then((response) => {
            resolve(response);
          })
          .finally(() => {
            HelperLoading.hideLoading();
          });
      }
    });
  };

  const getCatalog = (catalogoTipo: string) => {

    return new Promise<IapCatalog[]>((resolve) => {
      if (container) {
        const outputData = Array<IapCatalog>()
        const _srv = container.get<IServiceCatalog>(TYPES.CATALOG_REPOSITORY);
        HelperLoading.showLoading();
        fetchWrapper.get(Environment.URL_CATALOG + catalogoTipo + '.json')
          .then((response: IapCatalog) => {
            outputData.push(response);
            resolve(outputData);
          })
          .catch((response) => {
            HelperLoading.showLoading();
            _srv
              .getCatalogByType(catalogoTipo)
              .then((response) => {
                resolve(response);
              })
              .finally(() => {
                HelperLoading.hideLoading();
              });

          })
          .finally(() => {
            HelperLoading.hideLoading();
          });


      }
    });

  };

  const getCatalogs = (catalogoTipos: string[]) => {
    
    return new Promise<IapCatalog[]>((resolve) => {   

        const procs = Array()
        let outputData = Array<IapCatalog>()
        HelperLoading.showLoading();
        catalogoTipos.forEach(cat => {

          procs.push(fetchWrapper.get(Environment.URL_CATALOG + cat + '.json')
              .then((response: IapCatalogType) => {
                outputData = outputData.concat(response.iapCatalogs)
              }))      
        });

        Promise.all(procs).then(() => {
          resolve(outputData);
        }).finally(()=>{
          HelperLoading.hideLoading();
        })

      })

  
  };

  



  const getCatalogTypeByFieldId = (key: string) => {
    const item = (tablasData.value as IapDataSourceField[]).find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == key)
    return item?.catalogTypeId ?? ''
  };


  const existeCampoFiltrado = (t: IapDataSourceField) => {
    return (dataFilter.value.filter((h: { field: IapDataSourceField; }) => h.field == t).length > 0)
  }

  const getCatalogData = (tipoCatalogoid: string) => {
    return catalogos.filter(x => x.typeId == tipoCatalogoid).sort((a: { order: number; }, b: { order: number; }) => { return a.order - b.order; })
  }

  

  const formatData = (originaldata: any, columna: string) => {
    var data = originaldata[columna];
    var field = (tablasData.value as IapDataSourceField[]).find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == columna);

    // busca los customs
    if (field == undefined){
      field = (tablasData.value as IapDataSourceField[]).find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.fieldAlias) == columna);
    }
    
    if (field) {
     
      if (isIdCampoType(field,CatalogDataTypeConst.DATE)) {
        data = formateaFecha(data);
      }
      
      if (isIdCampoType(field,CatalogDataTypeConst.DATETIME)) {
        data = formateaFechaHora(data);
      }

      if (isType(field, SqlTypesConst.BIT)) {
        data = ((data ?? false)) === false ? 'No' : 'Sí';
      }

      if (isIdCampoType(field,CatalogDataTypeConst.MONEY)) {        
       data = HelperCommon.formateaMoneda(data);
      }

      if (isIdCampoType(field,CatalogDataTypeConst.PERCENT)) {        
        data = HelperCommon.formateaPorcentaje(data);
      }

      if (isCatalogType(field)) {
        const oldvalue = data
        data = catalogos.find(x => x.id.toLowerCase() == data?.toLowerCase())?.description ?? oldvalue;
      }

      if (hasLookUpType(field)) {
        const keys = Object.keys(originaldata);
        const newColumn = columna + DataSourceConst.DELIMITERFIELDLOOKUPDESCRIPTION;
        if (keys.includes(newColumn)){
          data = originaldata[newColumn];
        }
      }

    }
    return data;
  }

  const mustFormatData = (columna: string) => {
    
    if (tablasData.value) {
      var field = (tablasData.value as IapDataSourceField[]).find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == columna);
      if (field) {
        if (isType(field, SqlTypesConst.DATETIME) || isType(field, SqlTypesConst.TIME) || isType(field, SqlTypesConst.DATE)) {
          return true
        }
        if (isType(field, SqlTypesConst.BIT)) {
          return true
        }
        if (isType(field, SqlTypesConst.MONEY) || isType(field, SqlTypesConst.DECIMAL)) {
          return true
        }
        if (isType(field, SqlTypesConst.VARCHAR) && isCatalogType(field)) {
          return true
        }

      }
      return false;
    }
    return false;
  }

  const generateFormatCol = (_data: any) => {    
    
    _data.forEach((data: {}) => {
      const keys = Object.keys(data);
      keys.forEach(k => {
        const colName = k + DataSourceConst.DELIMITERFIELDFORMAT
        const zz = data as any
        zz[colName] = formatData(data, k)
      })

    })
  }


  
  const resolveFilterExpression = (field: IapDataSourceField, expressionsInput: IapExpression[] | null = null) => {

    const expData = expressionsInput ?? props.Component.expressions;
    const cds = dscInput ?? props.compDataSource
    let resu :any
    const expressions = expData?.filter((x: IapExpression) => x.idTypeExpression == CatalogExpConst.EXP_DEFAULTVALUES
    && x.idObjeto == CatalogObjectTypeConst.DSF && x.objetoId == [field.id, cds.id].join('#'))
    expressions?.filter((x:IapExpression) => x.iapExpressionDetails?.length > 0).forEach((exp: IapExpression) => {
    const localData = LocalService.getValue(LocalService.COMPONENTS_EXP + (props.rootParentId ?? -1).toString());
    const data = JSON.parse(localData ?? '[]')
    resu = ExpresionEngine.resolveExpressions(exp.iapExpressionDetails, data as any)
    
    //resu = resu?.toString();
    if (resu) {
        if (Object.keys(resu).length == 0) {
            resu = resu?.toString();
        }
    }
});


return resu;

}

  const getDefaultvalue = (data: IapDataSourceField, alternateDefaultValue:string | null = null, expressionsInput: IapExpression[] | null = null) => {
    // las expresiones de los filtros sobre los dsf estan por encima de los valores por defecto del dsf
    const expvalue = resolveFilterExpression(data,expressionsInput);
    if (expvalue){
        return expvalue;
    }

    const defaultValue = alternateDefaultValue ?? data.defaultValue;
    if (defaultValue) {
        const i = defaultValue.startsWith('((') ? 2 : 1;
        let _valor = defaultValue.substring(i, defaultValue.length - i)
        //@ts-ignore:disable-next-line
        _valor = _valor.replaceAll('(', '').replaceAll(')', '')
        if (_valor.toLocaleLowerCase() == 'getdate') {
            return new Date()
        }
        if (_valor.toLocaleLowerCase() == 'newid') {
          return HelperUtils.newGuid()          
      }
        if (_valor.toLocaleLowerCase() == 'getcurrentuser') {
            return store.getters.currentUser.id
        }

        if (defaultValue.toLocaleLowerCase() == 'getdate()') {
            return new Date()
        }
       if (defaultValue.toLocaleLowerCase() =='newid()') {
          return HelperUtils.newGuid()          
        }
        if (defaultValue.toLocaleLowerCase() == 'getcurrentuser()') {
            return store.getters.getCurrentUser.id
        }

        if (isType(data, SqlTypesConst.BIT)) {
            return Boolean(JSON.parse(_valor))
        }
        else {
            return _valor
        }

    }

    return null;
}
 

const insertEmptyRowToDataSource =  (expressionsInput: IapExpression[] | null = null) => {
  dscInput.dataSource.items = [{}];
  const keys = dscInput.dataSource.iapDataSourceFields.forEach(x =>
    {
      
      const alternateDefVal = dscInput.iapComponentDataSourceFieldConfigurations.find(c => c.dataSourceFieldId == x.id)?.defaultValue;
      dscInput.dataSource.items[0][dscInput.dataSource?.iapDataSourceDataBase?.idBaseDatos + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field] = getDefaultvalue(x,alternateDefVal, expressionsInput)    
    }
  )
  
}

const clearRowsToDataSource =  () => {
  dscInput.dataSource.items = null;
  
}


  return {
    catalogos,
    dataFilter,
    dataSearchResult,
    tablas,
    tablasData,
    dataBaseId,
    //getTables,
    getDataSource,
    isType,
    isCatalogType,
    isCatalogTypeByFieldId,
    getCatalog,
    getCatalogs,
    existeCampoFiltrado,
    getCatalogData,
    isFilterVisible,
    getCatalogTypeByFieldId,
    isIdCampoType,
    isColumnType,
    isColumnIdtipoCampoType,
    formatData,
    generateFormatCol,
    mustFormatData,
    isTableType,
    hasLookUpByFieldId,
    getLookUpByFieldId,
    hasLookUpByFieldType,    
    getDefaultvalue,
    insertEmptyRowToDataSource,
    clearRowsToDataSource

  };
}
